import { flushSync } from 'react-dom';
import React, { useState, useEffect, useContext, useRef } from 'react';
import { LegacyStack, Link, Text } from '@shopify/polaris';
import Address from './Address'
import ProxyForm from '../ProxyForm'
import EditPassword from '../../EditPassword'
import EditContact from '../../EditContact'
import { CustomerContext } from '../../contexts/Customer'
import { ShopContext } from '../../contexts/Shop'
import { HostContext } from '../../contexts/Host'
import { FormProvider, useFetch, Util } from '@thinkwell/react.common'
import { ProductsContext } from "../../contexts/Products";
import { ProductsYolkContext } from "../../contexts/yolk/Products";
import { Spinner } from "@thinkwell/react.polaris";
import { UserContext } from "../../contexts/yolk/User";
import { EnrollmentsContext } from "../../contexts/yolk/Enrollments";
import { SubscriptionsContext } from "../../contexts/Subscriptions";

export default function ResourceGroup(props) {
  const resourceGroup = props.resource_group;
  const resources = props.resources;
  const [ open, setOpen ] = useState(false)

  const resourcesEl = (<LegacyStack vertical={true}>
    {
      resources.map(resource => {
        return (<a style={{paddingLeft: "20px"}} key={resource.title} href={resource.url} target="_blank">{resource.title}</a>)
      })
    }
  </LegacyStack>);

  const toggleOpen = () => {
    setOpen(!open)
  }

  return (!resourceGroup.is_default ? <div style={{paddingLeft: "20px"}}>
      <Link onClick={toggleOpen}><Text as="h3" fontWeight="semibold">{resourceGroup.title}</Text></Link>
      { open ? <div style={{paddingTop: "10px"}}>{resourcesEl}</div> : null }
  </div> : <div>
    { resourcesEl }
  </div>)
}
